<template>
  <label class="uploader" @drop.prevent="drop" @dragover.prevent>
    <div class="uploader__placeholder">
      <div class="uploader__placeholder-top">
        {{ value ? value.name : placeholderTitle }}
      </div>
      <div class="uploader__placeholder-bottom" v-if="!value">
        {{ placeholderDesc }}
      </div>
    </div>
    <input
      accept="image/*,video/*"
      @change="handleChange"
      class="uploader__input"
      type="file"
    />
  </label>
</template>

<script>
export default {
  name: "Uploader",
  props: {
    value: File,
    placeholderTitle: String,
    placeholderDesc: String
  },
  methods: {
    handleChange(event) {
      const file = event.target.files[0];
      this.$emit("input", file);
    },
    drop(e) {
      const file = e.dataTransfer.files[0];
      this.$emit("input", file);
    }
  }
};
</script>

<style scoped lang="scss">
.uploader {
  display: flex;
  /* dashed border */
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%23333' stroke-width='2' stroke-dasharray='15%2c 7' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  border-radius: 10px;
  height: 100px;
  width: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    color: $primary;
  }

  &__placeholder {
    &-top {
      font-weight: 400;
      font-size: 20px;
      line-height: 1.3;
      margin-bottom: 0.25em;
    }
    &-bottom {
      font-weight: 400;
      font-size: 10px;
      line-height: 1.2;
      text-align: center;
    }
  }

  &__input {
    display: none;
  }
}

@media screen and (max-width: 960px) {
  .uploader {
    padding: 42px;
  }
}
</style>
